import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  nNumber,
  nString,
  uNumber,
} from '@hidat/huijs-common';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { ResourceConfig } from '@hidat/huijs-resource';
import { splixerSystemFields } from './splixer-fields.const';

export const RawMapConfig = new ResourceConfig(
  'RawMap',
  'raw_maps',
  false,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    new FieldConfig('type'),
    new FieldConfig('resourceType'),
    new FieldConfig('resourceId', FieldDataTypes.INTEGER),
    new FieldConfig('remoteCode'),
    new FieldConfig('remoteId', FieldDataTypes.INTEGER),
    new FieldConfig('content', FieldDataTypes.HASH).setEditable(false),
  ]);

export interface RawMapInterface extends SplixerResourceInterface<number> {
  stationId: uNumber;
  channelId: uNumber;
  type: 'RawProgram' | 'RawHost' | undefined;
  content: AnyHash | undefined;
  resourceType: 'Program' | 'Host' | undefined | null;
  resourceId: nNumber;
  remoteId: nNumber;
  remoteCode: nString;
}
